import Link from "next/link";
import React from "react";
import StoreItem from "../StoreItem";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Component to display a collection with its products in a horizontal scrollable list
 *
 * @param {Object} props - Component props
 * @param {Array} props.cohort - Store cohort information
 * @param {string} props.collectionName - Name of the collection
 * @param {Array} props.productsData - Array of products in the collection
 */
const FeaturedCollectionWithProd = ({ cohort, collectionName, productsData, themeData }) => {
  const products = productsData || [];

  if (products.length === 0) {
    return null;
  }

  const formattedCollectionName = capitalizeFirstLetter(collectionName ? collectionName : "");
  const collectionUrl = `/shop?collection=${encodeURIComponent(collectionName)}`;

  const isVerticalScroll = themeData?.collectionScrollDirection === "vertical";

  return (
    <div className="m-5">
      <h2 className="mx-[10px] mb-[30px] mt-[50px] text-center text-xl font-bold text-fontBackground">
        {formattedCollectionName}
      </h2>

      {isVerticalScroll ? (
        // Vertical grid layout
        <div className="grid grid-cols-2 gap-x-3">
          {products.map((product) => (
            <StoreItem
              key={product.id}
              cohort={cohort}
              product={product}
              pageSize={products.length}
            />
          ))}
        </div>
      ) : (
        // Horizontal scroll layout
        <div className="hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap">
          {products.map((product) => (
            <StoreItem
              cohort={cohort}
              usedForCollectionhome={true}
              key={product.id}
              product={product}
              pageSize={products.length}
            />
          ))}
        </div>
      )}

      <Link href={collectionUrl}>
        <a className="mx-auto my-2 block w-[90px] border border-primary px-4 py-2 text-center text-sm text-primary transition duration-300 ease-in-out hover:bg-primary hover:text-fontPrimary">
          View All
        </a>
      </Link>
    </div>
  );
};

export default FeaturedCollectionWithProd;
